<div class="container">
  <mat-card class="not-available-card not-available-text">
    <p>
      Access Denied. Your session is invalid or has expired. Please request a new access link.
    </p>
  </mat-card>
</div>
